Cm.main = {
    popCDNXPlayer: function() {
        id = (new Date()).getTime();

        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var systemZoom = width / window.screen.availWidth;
        var left = (width - 380) / 2 / systemZoom + dualScreenLeft;
        var top = (height - 660) / 2 / systemZoom + dualScreenTop;
        var position = 'width=' + 380 / systemZoom + ', height=' + 660 / systemZoom + ', top=' + top + ', left=' + left;

        eval("page" + id + " = window.open('https://player.cdnx.co.uk', '" + id + "', 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0," + position + "');");
    },
    init: function() {
        $('a.btn-open-cdnx').on('click', function() {
            Cm.main.popCDNXPlayer();
        });
    }
};